// Module
var code = "<% data.departments.forEach(function(department) { %> <h2 id=\"<%= department.id %>\"><%= department.name %></h2> <ul class=\"c-jobs__list\"> <% department.jobs.forEach(function(job) { %> <li> <a href=\"<%= job.url %>\"><%= job.title %></a> <span><%= job.location %></span> </li> <% }) %> </ul> <% }) %> ";
// Exports
module.exports = code;